import classNames from 'classnames';
import type { ButtonHTMLAttributes, FC } from 'react';

import styles from './Button.module.scss';

type Variant = 'primary' | 'success';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  variant?: Variant;
}

export const Button: FC<ButtonProps> = ({
  className,
  children,
  variant = 'primary',
  ...props
}) => (
  <button
    className={classNames(styles.container, styles[variant], className)}
    {...props}
    type="button"
  >
    {children}
  </button>
);
